<template>
    <div>
        <h5 class="card-title">{{$t('content.lesson.upload')}}:</h5>
        <PDFViewer :url="pdf(data)"/>
    </div>
</template>

<script>
import PDFViewer from '../../Common/PDFViewer/PDFViewer';

export default {
    name: 'ContentPDF',
    components: {
        PDFViewer,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        pdfembed({
            host,
            original_file,
        }, size = 'original') {
            // Verificar se temos uma URL assinada disponível no localStorage
            const signedUrls = localStorage.getItem(`content_${this.data.id_lesson_content}_download_urls`);

            if (signedUrls) {
                const urls = JSON.parse(signedUrls);
                if (urls && urls.show) {
                    // Se temos uma URL assinada para visualização, usamos ela em um iframe do Google Docs
                    return `https://docs.google.com/viewer?url=${encodeURIComponent(urls.show)}&embedded=true`;
                }
            }

            return `https://docs.google.com/viewer?url=${location.origin}/app/files/download/${this.data.id_lesson_content}/${this.data.secret}/show&embedded=true`;
        },
        pdf({
            host,
            original_file,
        }, size = 'original') {
            // Verificar se temos uma URL assinada disponível no localStorage
            const signedUrls = localStorage.getItem(`content_${this.data.id_lesson_content}_download_urls`);

            if (signedUrls) {
                const urls = JSON.parse(signedUrls);
                if (urls && urls.show) {
                    // Se temos uma URL assinada para visualização, usamos ela
                    return urls.show;
                }
            }

            return `/app/files/show/${this.data.id_lesson_content}/${this.data.secret}`;
        },
    },

};
</script>

<style>

</style>
